/* eslint-disable css-modules/no-undef-class, css-modules/no-unused-class */
import { FC, useState } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { NotificationTypes } from './notificationTypes';
import styles from './notification.module.scss';

const Notification: FC<NotificationTypes> = (props: NotificationTypes) => {
    const { sentDate, content, className, top, refFunction } = props;
    const [isHover, setIsHover] = useState<boolean>(false);

    const getTimeCompletedElement = (date: Date) => {
        moment.locale('en', {
            relativeTime: {
                future: 'in %s',
                past: '%s ago',
                s: 'a sec ago',
                ss: '%ss ago',
                m: 'a minute ago',
                mm: '%dm ago ',
                h: '%d hour ago',
                hh: '%dh ago',
                d: 'a day ago',
                dd: '%dd ago',
                M: 'a month ago',
                MM: '%dM ago',
                y: 'a year ago',
                yy: '%dY ago'
            }
        });
        return moment(date).fromNow(true);
    };
    return (
        <div
            ref={refFunction}
            className={classNames(styles.notification, className)}
            onMouseOver={(): void => setIsHover(true)}
            onMouseLeave={(): void => {
                setIsHover(false);
            }}
            style={{ '--top': `${top}rem` } as any}
        >
            <div className={styles['profile-picture']}>
                <img
                    src={`${process.env.PUBLIC_URL}/images/defaultProfilePicture.svg`}
                    className={styles['image-circle-picture']}
                    alt="profile"
                />
            </div>
            <div className={styles['user-name-content-wrapper']}>
                <div className={styles.content} title={content}>
                    {content}
                </div>
            </div>
            <div className={styles['date-dismiss-wrapper']}>
                <div className={styles.date}>{getTimeCompletedElement(sentDate)}</div>
                {isHover && <div className={styles.hover}></div>}
            </div>
        </div>
    );
};

export default Notification;
